<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="relative py-10 sm:py-0">
      <button
        @click="backToInitial()"
        class="cursor-pointer z-10 absolute top-0 mt-0 sm:mt-3 left-0 flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="rgb(79 70 229)"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <div class="text__view flex flex-col justify-center text-center mb-5">
        <h1 class="font-semibold text-2xl my-5">
          Cognitive principles that affect your marketing
        </h1>
        <p class="leading-6 max-w-5xl mx-auto">
          These marketing psychology principles will show you why consumers
          behave the way they do, and how you should use that in your
          advertising. It's more important now than ever to know why the
          customer chose brand A instead of a very similar brand B.
        </p>
      </div>

      <div
        class="tips__wrapper grid-cols-1 sm:grid-cols-2 py-10 justify-center justify-items-center lg:py-10"
      >
        <div class="pt-5 sm:pt-16 px-5 sm:px-8 pb-5 sm:border-r-2">
          <div class="py-8 pr-3 px-5 sm:px-0 sm:pr-8">
            <h1
              class="text-left font-semibold text-2xl sm:text-3xl text-blue-900"
            >
              Cognitive principles that affect your marketing
            </h1>
          </div>
          <div class="px-5 sm:px-0">
            <h3 class="font-semibold">Select a Category</h3>
            <div class="grid grid-flow-col mt-5 gap-3 sm:gap-0">
              <div v-for="item in content" :key="item.category">
                <div
                  @click="selectCategory(item.category)"
                  class="cursor-pointer flex-col items-center gap-2 w-20 h-20 sm:w-24 sm:h-24 flex justify-center p-5 rounded-lg border-gray-400 border-2 duration-300"
                  :class="{
                    'bg-indigo-300':
                      selectedCategory.category === item.category,
                  }"
                >
                  <Icon
                    :name="item.icon.name"
                    :viewbox="item.icon.viewbox"
                    :fill="
                      selectedCategory.category === item.category
                        ? '#fff'
                        : '#5a67d8'
                    "
                    :stroke="
                      selectedCategory.category === item.category
                        ? '#fff'
                        : '#5a67d8'
                    "
                    class="w-20 h-20"
                  />
                  <p
                    class="text-xs font-semibold"
                    :class="{
                      'text-white': selectedCategory.category === item.category,
                    }"
                  >
                    {{ item.category }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-start pl-6 flex-col pt-16 sm:pt-10">
          <div
            class="flex flex-row items-center gap-3 my-5"
            v-for="(info, index) in actualSlice"
            :key="index"
          >
            <div
              class="bg-indigo-600 p-3 w-16 h-16 flex items-center justify-center rounded-full"
            >
              <div
                class="border-2 p-3 w-13 h-13 flex items-center justify-center rounded-full"
              >
                <Icon
                  name="Lamp"
                  viewbox="0 0 33.469 33.561"
                  fill="#fff"
                  stroke="none"
                  class="w-8"
                />
              </div>
            </div>

            <div>
              <h3 class="text-indigo-600 font-semibold mb-2">
                {{ info.title }}
              </h3>
              <p class="text-sm">
                {{ info.content }}
              </p>
            </div>
          </div>
          <div class="flex flex-row gap-4 h-10 justify-center items-center">
            <div class="flex gap-3" v-if="selectedCategory.list_info">
              <button
                @click="decrementpage()"
                class="cursor-pointer flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
              >
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="rgb(79 70 229)"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <button
                @click="incrementpage()"
                class="cursor-pointer flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
              >
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="rgb(79 70 229)"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <ul class="flex flex-row">
              <li
                class="px-3 cursor-pointer text-sm text-gray-600"
                :class="{
                  'font-bold': page === currentPage,
                }"
                v-for="(page, index) in pages"
                :key="index"
                @click="currentPage = page"
              >
                {{ page }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onBeforeMount } from "vue";
import { useStore } from "vuex";
// import Icon from "@/components/UI/Icon";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import Icon from "@/components/UI/Icon";
import { useRouter } from "vue-router";
export default {
  components: { HeaderApp, AdblockTopbar, Icon },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });
    const pages = computed(() => {
      let pages = [];
      const numberPages = selectedCategory.value.list_info
        ? Math.ceil(selectedCategory.value.list_info.length / 4)
        : [];
      for (let i = 1; i <= numberPages; i++) {
        pages.push(i);
      }
      return pages;
    });
    const currentPage = ref(null);
    const actualSlice = computed(() => {
      let valueCurrent = currentPage.value ? currentPage.value : 1;
      let value = valueCurrent > 1 ? (valueCurrent - 1) * 4 : valueCurrent - 1;
      return selectedCategory.value.list_info
        ? selectedCategory.value.list_info.slice(value, valueCurrent * 4)
        : [];
    });
    const incrementpage = async () => {
      if (currentPage.value < pages.value.length) {
        currentPage.value++;
      }
    };

    const decrementpage = async () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const content = computed(() => [
      {
        category: "Information",
        icon: {
          name: "Information",
          viewbox: "0 0 512.001 512.001",
        },
        list_info: [
          {
            title: "Hicks Law",
            content: "More options leads to harder decisions",
          },
          {
            title: "Confirmation Bias",
            content: "People look for evidence that confirms what they think ",
          },
          {
            title: "Nudge",
            content: "Subtle hints can affect users' decisions",
          },
          {
            title: "Progressive Disclosure",
            content:
              "Users are less overwhelmed if they're exposed to complex features later",
          },
          {
            title: "Empathy Gap",
            content:
              "People underestimate how much emotions influence user behaviors",
          },
          {
            title: "Visual anchors",
            content: "Elements used to guide users' eyes",
          },
          {
            title: "Von Restorff Effect",
            content: "People remember more items that stand out",
          },
          {
            title: "Visual Hierarchy",
            content: "The order in which people perceive what they see",
          },
          {
            title: "Sensory Adaptation",
            content: "Users tune out the stuff they get repeatedly exposed to",
          },
          {
            title: "Juxtaposition",
            content:
              "Elements that are close and similar are perceived as a single unit",
          },
          {
            title: "Contrast",
            content: "Users' attention is drawn to higher visual weights",
          },
          {
            title: "Centre-Stage Effect",
            content:
              "People tend to choose the middle option in a set of items",
          },
          {
            title: "Framing",
            content:
              "The way information is presented affects how users make decisions",
          },
          {
            title: "Spark Effect",
            content:
              "Users are more likely to take action when the effort is small",
          },
        ],
      },
      {
        category: "Meaning",
        icon: {
          name: "Question",
          viewbox: "0 0 512.001 512.001",
        },
        list_info: [
          {
            title: "Social Proof",
            content: "Users adapt their behaviors based on what others do",
          },
          {
            title: "Scarcity",
            content: "People value things more when they're in limited supply",
          },
          {
            title: "Familiarity Bias",
            content: "People prefer familiar experiences ",
          },
          {
            title: "Skeuomorphism",
            content:
              "Users adapt more easily to things that look like real-world objects",
          },
          {
            title: "Authority Bias",
            content:
              "Users attribute more importance to the opinion of an authority figure",
          },
          {
            title: "Variable Reward",
            content: "People enjoy rewards, especially unexpected ones",
          },
          {
            title: "Aha! moment",
            content: "When new users first realize the value of your product",
          },
          {
            title: "Goal Gradient Effect",
            content: "Motivation increases as users get closer to their goal",
          },
          {
            title: "Occam’s Razor",
            content:
              "Simple solutions are often better than the more complex ones",
          },
          {
            title: "Noble Edge Effect ",
            content: "Users tend to prefer socially responsible companies ",
          },
        ],
      },
      {
        category: "Time",
        icon: { name: "Time", viewbox: "0 0 33.624 33.61" },
        list_info: [
          {
            title: "Labor illusion",
            content:
              "People value things more when they see the work behind them",
          },
          {
            title: "Temptation Coupling",
            content:
              "Hard tasks are less scary when coupled with something users desire",
          },
          {
            title: "Pareto Principle",
            content: "Roughly 80% of the effects come from 20% of the causes",
          },
          {
            title: "Planning Fallacy",
            content:
              "People tend to underestimate how much time a task will take",
          },
        ],
      },
      {
        category: "Memory",
        icon: { name: "Brain", viewbox: "0 0 29.592 32.905" },
        list_info: [
          {
            title: "Peak-End Rule",
            content: "People judge an experience by its peak and how it ends.",
          },
          {
            title: "Sensory Appeal",
            content:
              "Users engage more with things appealing to multiple senses",
          },
          {
            title: "Chunking",
            content: "People remember grouped information better ",
          },
          {
            title: "Picture Superiority Effect",
            content: "People remember pictures better than words",
          },
          {
            title: "Method of Loci",
            content:
              "People remember things more when they're associated with a location ",
          },
          {
            title: "Storytelling Effect",
            content: "People remember stories better than facts alone",
          },
        ],
      },
    ]);
    const backToInitial = () => {
      router.push("/psychology");
    };
    const selectedCategory = ref({});
    const selectCategory = (value) => {
      currentPage.value = 1;
      selectedCategory.value = content.value.find(
        (element) => element.category == value
      );
    };
    const roleUser = computed(() => store.state.role);

    return {
      content,
      roleUser,
      selectedCategory,
      selectCategory,
      backToInitial,
      pages,
      actualSlice,
      currentPage,
      incrementpage,
      decrementpage,
    };
  },
};
</script>

<style scoped>
.tips__wrapper {
  @apply grid;
}
.button__tips {
  border-radius: 20px;
}
.button__tips-text::before {
  display: block;
  content: " ";
  height: 3px;
  width: 20%;
  position: absolute;
  left: 40%;
  top: -15px;
  margin-bottom: 10px;
  margin-right: 10px;
  @apply bg-indigo-600;
}
</style>
